class SwiperIngredient extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.btnSwiper = null;
    this.mql = null;

    this._mqHandler   = this._mqHandler.bind(this);
    this._onBtnClick  = this._onBtnClick.bind(this);
    this._setActive   = this._setActive.bind(this);
    this._scrollBtnTo = this._scrollBtnTo.bind(this);

    this.container = null;
    this.buttons = [];
    this.buttonSlides = [];
    this.imgWrap = null;
    this.imgs = [];
    this.slides = [];
    this.wrapper = null;
    this.paginationEl = null;
  }

  connectedCallback() {
    this.container = this.closest('.ingredients__container') || this.parentElement || document;

    this.buttons = Array.from(this.container.querySelectorAll('.bundle-switch__btn'));
    this.buttonSlides = Array.from(this.container.querySelectorAll('.swiper-bundle .swiper-slide'));
    this.imgWrap = this.container.querySelector('.ingredients__img');
    this.imgs    = this.imgWrap ? Array.from(this.imgWrap.querySelectorAll('img[data-prod]')) : [];
    this.wrapper = this.querySelector('.swiper-ingredient .swiper-wrapper');
    this.paginationEl = this.querySelector('.swiper-pagination');
    this.slides  = this.wrapper ? Array.from(this.wrapper.querySelectorAll('.swiper-slide[data-prod]')) : [];

    this.buttons.forEach(b => b.addEventListener('click', this._onBtnClick));

    this.mql = window.matchMedia('(min-width: 989px)');
    this.mql.onchange = this._mqHandler;
    this._mqHandler(this.mql);

    const firstIdx = this.buttons[0]?.dataset.prod ?? '0';
    this._setActive(firstIdx);
  }

  disconnectedCallback() {
    if (this.mql) this.mql.onchange = null;
    this._destroySlider();
    this._destroyBtnSwiper();
    this.buttons.forEach(b => b.removeEventListener('click', this._onBtnClick));
  }

  _onBtnClick(e) {
    const idx = e.currentTarget.dataset.prod;
    this._setActive(idx);
  }

  _setActive(idx) {
    this.buttons.forEach(b => b.classList.toggle('is-active', b.dataset.prod === idx));
    this.buttonSlides.forEach(sl => sl.classList.toggle('is-active', sl.querySelector('.bundle-switch__btn')?.dataset.prod === idx));

    if (this.imgs.length && this.imgWrap) {
      const activeDesktop = this.imgs.find(i => i.getAttribute('data-prod') === idx && i.classList.contains('show-desktop'));
      const activeMobile  = this.imgs.find(i => i.getAttribute('data-prod') === idx && i.classList.contains('show-mobile'));
      this.imgs.forEach(el => el.classList.toggle('is-hidden', el.getAttribute('data-prod') !== idx));
      if (activeDesktop && this.imgWrap.firstElementChild !== activeDesktop) this.imgWrap.prepend(activeDesktop);
      if (activeMobile) this.imgWrap.append(activeMobile);
    }

    if (this.slides.length) {
      this.slides.forEach(el => {
        const show = (el.getAttribute('data-prod') === idx);
        if (this.swiper) {
          el.style.display = show ? '' : 'none';
        } else {
          el.style.display = show ? '' : 'none';
        }
      });
    }

    if (this.swiper) {
      try { this.swiper.update(); this.swiper.slideTo(0, 0); } catch(e) {}
    }

    this._scrollBtnTo(idx);
  }

  _scrollBtnTo(idx) {
    if (!this.btnSwiper) return;
    const slideIndex = this.buttonSlides.findIndex(sl => sl.querySelector('.bundle-switch__btn')?.dataset.prod === idx);
    if (slideIndex >= 0) {
      try { this.btnSwiper.slideTo(slideIndex, 300); } catch(e){}
    }
  }

  _mqHandler(e) {
    const isDesktop = !!e.matches;

    if (isDesktop) {
      this._destroySlider();
      this._destroyBtnSwiper();
      this._applyDesktopLayout();
    } else {
      this._clearDesktopLayout();
      if (!this.swiper) this._initSlider();
      if (!this.btnSwiper) this._initBtnSwiper();
    }
  }

  _applyDesktopLayout() {
    if (this.paginationEl) this.paginationEl.style.display = 'none';
  }
  _clearDesktopLayout() {
    if (this.paginationEl) this.paginationEl.style.display = '';
  }

  _initSlider() {
    const container = this.querySelector('.swiper-ingredient');
    if (!container) return;
    this.swiper = new Swiper(container, {
      slidesPerView: 1.8,
      initialSlide: 1,
      spaceBetween: 6,
      loop: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        700: { slidesPerView: 3, spaceBetween: 6 }
      },
      pagination: { el: this.querySelector('.swiper-pagination'), clickable: true },
    });
  }

  _destroySlider() {
    if (this.swiper) {
      try { this.swiper.destroy(true, true); } catch (e) {}
      this.swiper = null;
    }
  }

  _initBtnSwiper() {
    const el = this.container.querySelector('.swiper-bundle');
    if (!el) return;
    try {
      this.btnSwiper = new Swiper(el, {
        slidesPerView: 1.8,
        spaceBetween: 8,
        freeMode: true,
        watchOverflow: true,
        centeredSlides: false,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'progressbar'
        },
        breakpoints: {
          989: { 
            spaceBetween: 10,
            slidesPerView: 'auto'
          }
        }
      });
    } catch(e){}
  }

  _destroyBtnSwiper() {
    if (this.btnSwiper) {
      try { this.btnSwiper.destroy(true, true); } catch(e){}
      this.btnSwiper = null;
    }
  }
  
}

customElements.define('swiper-ingredient', SwiperIngredient);

